import {
    FortuneSearchBoxInner,
    FortuneSearchContsBottom,
    FortuneSearchContsBox,
    FortuneSearchContsTop,
    FortuneSearchSubTitle
} from "src/styles/views/UserPage/Fortune";
import CheckBoxForm from "src/component/common/CommonForm/CheckBoxForm";
import ReactDatePicker from "react-datepicker";
import {TimeOfBirthItems} from "src/component/common/Modal/TimeOfBirth";
import arrow from "src/assets/userPage/under_arrow.png";
import {CustomBtn} from "src/styles/common/CommonForm/buttonform";
import {COLOR} from "src/service/constant/color";
import Modal from "src/component/common/Modal/Modal";
import React, {useEffect, useState} from "react";
import {useModal} from "src/hooks/useModal";
import {useRecoilValue, useResetRecoilState, useSetRecoilState} from "recoil";
import 'react-datepicker/dist/react-datepicker.css'
import {FortuneResultData, TimeOfBirthState} from "src/store/UserPage/fortune";
import {useBirthDayFortuneQueryData} from "src/hooks/reactquery";
import {TYPE_BIRTHDAY_FORTUNE} from "src/service/constant/cmdtype";
import useWindowDimensions from "src/hooks/useGetWindowSize";
import dayjs from "dayjs";
import {ko} from 'date-fns/esm/locale';

const GenderRadioItems = [
    {idx: 0, text: "남자"},
    {idx: 1, text: '여자'}
]

const CalendarRadioItems = [
    {idx: 0, text: "양력"},
    {idx: 1, text: "음력"},
    {idx: 2, text: "음력(윤달)"}
]

const BirthFortuneSearch = () => {
    const [GenderState, setGenderState] = useState(0)
    const [SelectDate, setSelectDate] = useState<any>(null)
    const [CalendarState, setCalendarState] = useState(0)
    const {isOpen, toggle} = useModal()
    const [modalOption, setModalOption] = useState({type: ""})
    const TimeOfBirthValue = useRecoilValue(TimeOfBirthState)
    const [CalToggle, setCalToggle] = useState(false)
    const setUserFortuneData = useSetRecoilState(FortuneResultData)
    const ResetUserFortuneData = useResetRecoilState(FortuneResultData)
    const ResetUserBirthData = useResetRecoilState(TimeOfBirthState)
    const {width} = useWindowDimensions()
    const {
        mutateAsync: BirthFortuneSubmit
    } = useBirthDayFortuneQueryData(TYPE_BIRTHDAY_FORTUNE, GenderState, CalendarState, dayjs(SelectDate).format('YYYYMMDD'), TimeOfBirthValue)

    const ModalOpenFunc = (type: string) => {
        setModalOption({type: type})
        toggle()
    }

    const SearchSubmit = () => {
        BirthFortuneSubmit().then(r => setUserFortuneData(r?.Body))
    }

    useEffect(() => {
        if (CalToggle) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
    }, [CalToggle])

    useEffect(()=>{
        ResetUserFortuneData()
        ResetUserBirthData()
    },[ResetUserBirthData, ResetUserFortuneData])
    
    return (
        <>
            <h4>운세정보 입력</h4>
            <FortuneSearchContsTop>
                <FortuneSearchContsBox width={"150px"}>
                    <FortuneSearchSubTitle>성별</FortuneSearchSubTitle>
                    <CheckBoxForm
                        data={GenderRadioItems}
                        onChange={setGenderState}
                        checked={GenderState}
                    />
                </FortuneSearchContsBox>
                <FortuneSearchContsBox width={"336px"}>
                    <FortuneSearchSubTitle>양력/음력</FortuneSearchSubTitle>
                    <CheckBoxForm
                        data={CalendarRadioItems}
                        onChange={setCalendarState}
                        checked={CalendarState}
                    />
                </FortuneSearchContsBox>
            </FortuneSearchContsTop>
            <FortuneSearchContsBottom>
                <FortuneSearchContsBox width={width > 600 ? "49%" : "93%"}>
                    <FortuneSearchSubTitle>생년월일</FortuneSearchSubTitle>

                    <FortuneSearchBoxInner active={`${CalToggle}`}>
                        <ReactDatePicker
                            selected={SelectDate}
                            onChange={(date: any) => setSelectDate(date)}
                            peekNextMonth
                            dateFormat="yyyy/MM/dd"
                            showMonthDropdown
                            onFocus={event => event.target.blur()}
                            locale={ko}
                            minDate={new Date('1930/01/01')}
                            maxDate={new Date()}
                            onCalendarOpen={() => setCalToggle(true)}
                            onCalendarClose={() => setCalToggle(false)}
                            showYearDropdown
                            withPortal
                            placeholderText="생년월일"
                            dropdownMode="select"
                        />
                    </FortuneSearchBoxInner>
                </FortuneSearchContsBox>
                <FortuneSearchContsBox width={width > 600 ? "49%" : "93%"}>
                    <FortuneSearchSubTitle>출생시간</FortuneSearchSubTitle>
                    <FortuneSearchBoxInner onClick={() => ModalOpenFunc("timeOfBirth")}>
                        <span>{TimeOfBirthValue === 0 ? "모름" :
                            TimeOfBirthItems.find(element => element.idx === TimeOfBirthValue)?.text}</span>
                        <img src={arrow} alt=""/>
                    </FortuneSearchBoxInner>
                </FortuneSearchContsBox>
            </FortuneSearchContsBottom>
            <CustomBtn
                color={COLOR.white}
                bgColor={SelectDate === null ? COLOR.gray30 : COLOR.point1}
                borderRadius={"40px"}
                marginTop={width > 600 ? "58px" : "36px"}
                width={width > 600 ? "356px" : "328px"}
                height={width > 600 ? "56px" : "44px"}
                fontSize={width > 600 ? "18px" : "14px"}
                fontFamily={width > 600 ? "NanumSquareNeoHeavy, sans-serif" : "NotoSansBold, sans-serif"}
                onClick={SearchSubmit}
            >
                <span>오늘의 운세 조회하기</span>
            </CustomBtn>
            <Modal isOpen={isOpen} toggle={toggle} type={modalOption?.type} ClickFunc={() => toggle()}/>
        </>
    )
}
export default BirthFortuneSearch